import { Link } from "react-router-dom";

export default function About() {
  return (
    <div className="pt-28 md:pt-32 pb-20 bg-[#F9F6F0]" data-testid="about-page">
      <div className="max-w-[800px] mx-auto px-6">
        <h1
          className="text-3xl md:text-4xl font-semibold text-slate-900 text-center mb-10"
          data-testid="about-title"
        >
          About Blessings Connection
        </h1>

        <div className="space-y-8 text-base leading-relaxed text-slate-700">
          <section data-testid="about-section-01">
            <h2 className="text-xl font-medium mt-2 mb-3 text-slate-900">Who We Are</h2>
            <p>
              Blessings Connection LLC is a United States registered online retailer specializing in new
              books, textbooks, educational materials, and related reading products.
            </p>
          </section>

          <section data-testid="about-section-02">
            <h2 className="text-xl font-medium mt-8 mb-3 text-slate-900">Who We Serve</h2>
            <p>
              Our goal is to make quality books accessible to students, professionals, educators, and
              general readers through a reliable and customer-focused online shopping experience.
            </p>
          </section>

          <section data-testid="about-section-03">
            <h2 className="text-xl font-medium mt-8 mb-3 text-slate-900">Our Commitment</h2>
            <p className="mb-3">
              We are committed to offering competitive prices, secure online payments, prompt order
              processing, and responsive customer support.
            </p>
            <p>
              Every order is handled with care to ensure that customers receive authentic products
              and a professional level of service.
            </p>
          </section>

          <section data-testid="about-section-04">
            <h2 className="text-xl font-medium mt-8 mb-3 text-slate-900">How We Operate</h2>
            <p>
              Whether you are looking for academic textbooks, educational resources, or general reading
              material, Blessings Connection LLC provides a trusted online marketplace backed by
              transparent policies and reliable service.
            </p>
          </section>

          <section data-testid="about-business-info" className="border-t border-slate-200 pt-8 mt-10">
            <h2 className="text-xl font-medium mb-4 text-slate-900">Business Details</h2>

            <div className="space-y-4">
              <div>
                <p className="text-sm font-medium text-slate-500 uppercase tracking-wide">Company</p>
                <p className="mt-1 text-slate-800" data-testid="about-company-name">
                  Blessings Connection LLC
                </p>
              </div>

              <div>
                <p className="text-sm font-medium text-slate-500 uppercase tracking-wide">
                  Business Address
                </p>
                <address
                  className="mt-1 not-italic text-slate-800"
                  data-testid="about-business-address"
                >
                  Blessings Connection LLC<br />
                  5830 E 2nd St, Ste 7000 #24510<br />
                  Casper, WY 82609<br />
                  United States
                </address>
              </div>

              <div>
                <p className="text-sm font-medium text-slate-500 uppercase tracking-wide">
                  Customer Support
                </p>
                <a
                  href="mailto:customerservice@blessingsconnection.com"
                  data-testid="about-contact-email"
                  className="mt-1 inline-block text-slate-800 underline hover:text-[#7A2021]"
                >
                  customerservice@blessingsconnection.com
                </a>
              </div>
            </div>

            <div className="mt-8 flex flex-wrap gap-3">
              <Link
                to="/books"
                data-testid="about-cta-shop"
                className="border border-slate-900 px-5 py-2 text-sm text-slate-900 hover:bg-slate-900 hover:text-white transition-colors"
              >
                Browse the shop
              </Link>
              <Link
                to="/shipping"
                className="border border-slate-300 px-5 py-2 text-sm text-slate-700 hover:border-slate-900 hover:text-slate-900 transition-colors"
              >
                Shipping policy
              </Link>
              <Link
                to="/returns"
                className="border border-slate-300 px-5 py-2 text-sm text-slate-700 hover:border-slate-900 hover:text-slate-900 transition-colors"
              >
                Return policy
              </Link>
              <Link
                to="/contact"
                className="border border-slate-300 px-5 py-2 text-sm text-slate-700 hover:border-slate-900 hover:text-slate-900 transition-colors"
              >
                Contact us
              </Link>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
